var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactCardDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 333 224"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00427A",
  strokeMiterlimit: 16,
  strokeWidth: 11.869,
  d: "m141.605 55.134-18.324-109.97-21.988 109.97L53.651 33.14l25.654 47.653-139.26 18.328 139.26 21.994-25.654 47.654 47.642-25.66 21.988 340.906 18.324-340.906 47.641 25.66-18.323-47.654 124.601-21.994-124.601-18.328 18.323-47.653z"
})));
export default SvgContactCardDefault;